import { MatchResult } from '../../constants';

export const StatusColor = {
  [MatchResult.Win]: '#5FFFE4',
  [MatchResult.Draw]: '#FEF107',
  [MatchResult.Lose]: '#F73C69',
};
